import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import './App.css';
import LoadingScreen from './components/Common/LoadingScreen/LoadingScreen';
import PageLoader from './components/Common/PageLoader/PageLoader';
import ErrorBoundary from './components/Common/ErrorBoundary/ErrorBoundary';
import ErrorFallback from './components/Common/ErrorFallback/ErrorFallback';
import ScrollToTop from './components/ScrollToTop';
import { useLoadingScreen } from './stores/modalStore';

// Lazy load all pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const AboutUsPage = lazy(() => import('./pages/AboutUsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const ComingSoonPage = lazy(() => import('./pages/ComingSoonPage'));

function App() {
  const { isVisible: showLoading } = useLoadingScreen();

  // For non-Home pages, we'll use a simple loading completion
  const handleLoadingComplete = () => {
    // This will be overridden by individual pages
  };

  return (
    <ErrorBoundary
      fallback={<ErrorFallback type="page" />}
      onError={(error, errorInfo) => {
        console.error('App-level error:', error, errorInfo);
        // Here you would typically send to error tracking service
      }}
    >
      <Router>
        <ScrollToTop />
        <div className="App">
          {showLoading && <LoadingScreen onComplete={handleLoadingComplete} />}
          
          <div className="hyperspace-layer"></div>
          
          <Suspense fallback={showLoading ? null : <PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/legal" element={<LegalPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/blogs" element={<ComingSoonPage />} />
              <Route path="/case-studies" element={<ComingSoonPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;